import { css, cx } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"

import blueIcon from "./blueIcon.png"
import redIcon from "./redIcon.png"

type Props = {
  href: string
  theme: "red" | "blue"
  description: string
  highlightedDescription: string
}

const ImportantDescriptionLink = ({ href, theme, description, highlightedDescription }: Props) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={cx(styles.container, theme === "red" ? styles.containerRed : styles.containerBlue)}
    >
      <Image src={theme === "red" ? redIcon : blueIcon} alt="" width={18} height={18} className={styles.image} />
      <span className={styles.text}>{description}</span>
      <span className={cx(styles.read, theme === "red" ? styles.readRed : styles.readBlue)}>
        {highlightedDescription}
      </span>
    </a>
  )
}

export default ImportantDescriptionLink

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 320px;
    height: 48px;
    text-decoration: none;
    border-radius: 6px;
    &:hover {
      opacity: 0.7;
    }
  `,
  containerRed: css`
    color: #f5191f;
    background-color: #fbe2e2;
  `,
  containerBlue: css`
    color: #0071bc;
    background-color: #e9f3fe;
  `,
  image: css`
    position: relative;
    top: -1px;
  `,
  text: css`
    padding-right: 2px;
    padding-left: 5px;
  `,
  read: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 22px;
    color: white;
  `,
  readRed: css`
    background-color: #f5191f;
  `,
  readBlue: css`
    background-color: #0071bc;
  `,
}
